var map = {
	"./de/abilities_descriptions": [
		"lMAw",
		63
	],
	"./en/abilities_descriptions": [
		"RhBC",
		47
	],
	"./fr/abilities_descriptions": [
		"3AtL",
		31
	],
	"./nl/abilities_descriptions": [
		"F4we",
		15
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "HE10";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang lazy ^\.\/.*\/abilities_descriptions$
// module id = HE10
// module chunks = 97